import DoneIcon from 'assets/images/buySubscription/done.svg'
export default function Free() {
    return (
        <div className=" bg-white mx-2 my-3 p-3 rounded-2xl">
            <p className=" text-lg">امکانات نسخه‌ی رایگان</p>
            <div className=" flex my-2">
                <img src={DoneIcon} alt="done" className=" ml-2" />
                <p>امکان ساخت ۲ صندوق رایگان</p>
            </div>
            <div className=" flex my-2">
                <img src={DoneIcon} alt="done" className=" ml-2" />
                <p>امکان افزودن ۲۰‌ عضو</p>
            </div>
            <div className=" flex my-2">
                <img src={DoneIcon} alt="done" className=" ml-2" />
                <p>امکان تعریف ۲ وام در هر ماه</p>
            </div>
            <div className=" flex my-2">
                <img src={DoneIcon} alt="done" className=" ml-2" />
                <p>اطلاع رسانی رویدادها از طریق نوتیفیکیشن</p>
            </div>
            <div className=" flex my-2">
                <img src={DoneIcon} alt="done" className=" ml-2" />
                <p>ذخیره اطلاعات صندوق در فضای ابری</p>
            </div>
            <div className=" flex my-2">
                <img src={DoneIcon} alt="done" className=" ml-2" />
                <p>امکان ثبت دستی تراکنش‌ها</p>
            </div>
        </div>
    )
}
